import { Box, Typography } from '@mui/material';
import dynamic from 'next/dynamic';

const CountUp = dynamic(() => import('react-countup'), { ssr: false });
const Count = () => {
  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          p: 2,
          width: { lg: 200, xl: 260 },
          height: { lg: 100, xl: 120 },
          backgroundColor: '#76cef2',
          top: { lg: 27, xl: 47 },
          right: 575,
          borderRadius: 3,
          textAlign: 'center',
        }}
        className="animation-scale"
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 30, md: 30, lg: 40, xl: 50 },
            fontWeight: 700,
            color: '#000',
            lineHeight: 1,
          }}
        >
          <CountUp start={-10} end={60} duration={2.75} />+
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 16, md: 14, lg: 14, xl: 18 },
            fontWeight: 700,
            lineHeight: 1,
            color: '#000',
          }}
        >
          Forms
          <br />
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              color: '#414141',
              fontSize: { sm: 14, md: 12, lg: 11, xl: 14 },
            }}
          >
            Comprehensive tax coverage
          </Box>
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          p: 2,
          width: { lg: 200, xl: 260 },
          height: { lg: 100, xl: 120 },
          backgroundColor: '#8cd4ce',
          top: 170,
          right: 27,
          borderRadius: 3,
          textAlign: 'center',
        }}
        className="animation-right"
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 30, md: 30, lg: 40, xl: 50 },
            fontWeight: 700,
            color: '#000',
            lineHeight: 1,
          }}
        >
          <CountUp start={-10} end={40} duration={2.75} />+
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 16, md: 14, lg: 14, xl: 18 },
            fontWeight: 700,
            lineHeight: 1,
            color: '#000',
          }}
        >
          Features
          <br />
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              color: '#414141',
              fontSize: { sm: 14, md: 12, lg: 11, xl: 14 },
            }}
          >
            Simplifies your tax filing
          </Box>
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          p: 2,
          width: { lg: 200, xl: 260 },
          height: { lg: 100, xl: 120 },
          backgroundColor: '#eade70',
          top: 310,
          right: 785,
          borderRadius: 3,
          textAlign: 'center',
        }}
        className="animation-left"
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 30, md: 30, lg: 40, xl: 50 },
            fontWeight: 700,
            color: '#000',
            lineHeight: 1,
          }}
        >
          <CountUp start={-10} end={7} duration={2.75} />
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 16, md: 14, lg: 14, xl: 18 },
            fontWeight: 700,
            lineHeight: 1,
            color: '#000',
          }}
        >
          Form Groups
          <br />
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              color: '#414141',
              fontSize: { sm: 14, md: 12, lg: 11, xl: 14 },
            }}
          >
            Organized for easy filing
          </Box>
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          p: 2,
          width: { lg: 200, xl: 260 },
          height: { lg: 100, xl: 120 },
          backgroundColor: '#d8a1d2',
          bottom: 28,
          right: 360,
          borderRadius: 3,
          textAlign: 'center',
        }}
        className="animation-up"
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 30, md: 30, lg: 40, xl: 50 },
            fontWeight: 700,
            color: '#000',
            lineHeight: 1,
          }}
        >
          <CountUp start={-10} end={5} duration={2.75} />+
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { sm: 16, md: 14, lg: 14, xl: 18 },
            fontWeight: 700,
            lineHeight: 1,
            color: '#000',
          }}
        >
          FREE Forms
          <br />
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              color: '#414141',
              fontSize: { sm: 14, md: 12, lg: 11, xl: 14 },
            }}
          >
            Saves time and money
          </Box>
        </Typography>
      </Box>
    </>
  );
};

export default Count;
